module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "applyPopup"
  }, [_c('mt-header', {
    attrs: {
      "title": "发送申请意向"
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left",
      "icon": "back"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    },
    slot: "left"
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v(_vm._s(_vm.project.title))]), _vm._v(" "), _c('span', [_vm._v("项目预算：" + _vm._s(_vm.project.prepriceName))])]), _vm._v(" "), _c('div', {
    staticClass: "money"
  }, [_c('span', [_vm._v("您的报价是？")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.number),
      expression: "number"
    }],
    attrs: {
      "type": "number",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.number = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "describe"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.shwoDescribePopup
    }
  }, [_vm._v("意向怎么写？"), _c('icon', {
    attrs: {
      "name": "info-circle"
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v("说说你对项目的理解和申请意向")]), _vm._v(" "), _c('p', [_vm._v("(1000字以内)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    attrs: {
      "rows": "10"
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "serviceFee"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "selsect"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "checked",
      "checked": "checked",
      "id": "ch"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checked"
    }
  }, [_vm._v("如果项目成交则默认同意签署"), _c('span', {
    on: {
      "click": _vm.shwoContractPopup
    }
  }, [_vm._v("云智图三方服务合同")])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.sendapply
    }
  }, [_vm._v("发送申请")]), _vm._v(" "), _c('mt-popup', {
    staticClass: "popup",
    attrs: {
      "position": "right"
    },
    model: {
      value: (_vm.describePopup),
      callback: function($$v) {
        _vm.describePopup = $$v
      },
      expression: "describePopup"
    }
  }, [_c('mt-header', {
    attrs: {
      "title": "项目报价申请意向填写示例"
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left",
      "icon": "back"
    },
    on: {
      "click": _vm.hidenDescribePopup
    },
    slot: "left"
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    ref: "example",
    staticClass: "example"
  })], 1), _vm._v(" "), _c('mt-popup', {
    staticClass: "popup",
    attrs: {
      "position": "right"
    },
    model: {
      value: (_vm.contractPopup),
      callback: function($$v) {
        _vm.contractPopup = $$v
      },
      expression: "contractPopup"
    }
  }, [_c('mt-header', {
    attrs: {
      "title": "云智图第三方合同"
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left",
      "icon": "back"
    },
    on: {
      "click": _vm.hidenContractPopup
    },
    slot: "left"
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('p', [_vm._v("云智图第三方合作合同")]), _vm._v(" "), _c('div', {
    ref: "contract",
    staticClass: "contract"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f493442","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/projectApplyPopup.vue
// module id = 1267
// module chunks = 1